<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row"
      v-if="userData.permissions['view_student_attendance'] == 1"
    >
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="d-flex justify-content-end">
                <div>
                  <router-link to="/systemstudentrollcall">
                    <b-button class="mx-2" size="sm" variant="success"
                      ><i class="mdi mdi-calendar-check-outline"></i> Attendance
                      by system</b-button
                    ></router-link
                  >
                  <router-link to="/studentrollcall">
                    <b-button class="mx-2" size="sm" variant="info"
                      ><i class="mdi mdi-cellphone-nfc"></i> Attendance by
                      NFC</b-button
                    ></router-link
                  >
                  <router-link to="/">
                    <b-button class="mx-2" size="sm" variant="secondary"
                      ><i class="mdi mdi-fingerprint"></i> Attendance by
                      biometric</b-button
                    ></router-link
                  >
                </div>
              </div>
              <div class="my-2">
                <div class="row">
                  <b-form-group class="col-md-3" label="Term">
                    <v-select
                      :options="schoolterms"
                      placeholder="Select Term"
                      v-model="schoolterm"
                      label="name"
                    ></v-select>
                  </b-form-group>
                  <b-form-group class="col-md-3" label="Year">
                    <v-select
                      :options="years"
                      placeholder="Select Year"
                      v-model="year"
                    ></v-select>
                  </b-form-group>
                  <div class="col-md-4 mt-md-4 mt-2 p-lg-0">
                    <b-button variant="primary" @click="FilterData()"
                      ><i class="mdi mdi-account-search"></i> Filter</b-button
                    >
                  </div>
                </div>
              </div>

              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select
                        class="form-select form-select-sm mx-1"
                        v-model="perPage"
                        size="sm"
                        :options="Options"
                      ></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                  <template #table-busy
                    ><div class="text-center text-primary my-2">
                      <b-spinner
                        class="align-middle"
                        type="grow"
                        small
                      ></b-spinner>
                      <strong>No Data Selected Yet</strong>
                    </div></template
                  >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(photo)="data">
                    <img
                      :src="getFiles(data.item.student_id.student_photo)"
                      height="50"
                  /></template>
                  <template #cell(student)="data">
                    {{ data.item.student_id.first_name }}
                    {{ data.item.student_id.last_name }}<br />
                    <b style="color:red;"
                      >{{ data.item.student_id.student_id }}
                    </b>
                  </template>
                  <template #cell(schoolterm)="data">{{
                    data.item.schoolterm.name
                  }}</template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
// import Multiselect from "vue-multiselect";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  schooltermComputed,
  schooltermMethods,
  studentrollcallsComputed,
  studentrollcallsMethods,
  staffmemberComputed,
  staffmemberMethods,
} from "@/state/helpers";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Student Attendance ",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: " Student Attendance",
      items: [
        { text: "Dashboard", to: "/" },
        { text: " Student Attendance", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "photo", label: "Student Photo", visible: true },
        { key: "student", label: "Student", visible: true },
        { key: "schoolterm", label: "Term", visible: true },
        { key: "year", label: "Year ", visible: true },
        { key: "attendance_date", label: "Attendance date ", visible: true },
        { key: "checkin", label: "Checkin Time", visible: true },
        { key: "checkout", label: "Checkout Time", visible: true },
      ],
      id: "",
      student: "",
      photo: "",
      name: "",
      student_id: "",
      attendance_date: "",
      checkin: "",
      checkout: "",
      first_name: "",
      last_name: "",
      schoolterm: "",
      year: new Date().getFullYear(),
      loader: false,
    };
  },
  computed: {
    ...studentrollcallsComputed,
    ...schooltermComputed,
    ...staffmemberComputed,
    List() {
      return this.studentrollcalls.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.studentrollcalls.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.studentrollcalls.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearArray.push(year);
      }
      return yearArray;
    },
  },
  mounted() {
    this.FilterData();
    this.fetchSchoolTerms();
    this.fetchStudentRollcalls();
    this.fetchStaffMembers();
    this.TotalRows = this.studentrollcalls.length;
    this.isBusy = false;
    this.schoolterm = this.schoolterms.find((option) => option.active == 1);
  },
  methods: {
    ...studentrollcallsMethods,
    ...schooltermMethods,
    ...staffmemberMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id) {
      this.id = id;
      this.$bvModal.show("end-attendance");
    },
    async endattendance() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/captureattendance";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchStudentRollcalls();
          this.$bvModal.hide("end-attendance");
        }
      });
    },
    FilterData() {
      this.filterStudentRollcall({
        schoolterm: this.schoolterm.id,
        year: this.year,
      });
    },
    getFiles(name) {
      let url = axios.defaults.baseURL;
      let imagelink = url.slice(0, -3) + "students/" + name;
      return imagelink;
    },
  },
};
</script>
